export default {
      id: "ic_youtube-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_youtube-usage",
      toString: function () {
        return this.url;
      }
    }